"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregatorTrade = void 0;
const currency_1 = require("@zenlink-interface/currency");
const math_1 = require("@zenlink-interface/math");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const TradeVersion_1 = require("../TradeVersion");
class AggregatorTrade {
    constructor(chainId, inputAmount, outputAmount, executionPrice, priceImpact, routeLegs, callMethod, writeArgs) {
        this.version = TradeVersion_1.TradeVersion.AGGREGATOR;
        this.chainId = chainId;
        this.inputAmount = inputAmount;
        this.outputAmount = outputAmount;
        this.executionPrice = executionPrice;
        this.priceImpact = priceImpact;
        this.routeLegs = routeLegs;
        this.callMethod = callMethod;
        this.writeArgs = writeArgs;
    }
    get descriptions() {
        return this.routeLegs.map(({ tokenFrom, tokenTo, poolFee, poolType, absolutePortion, poolAddress, }) => ({
            input: tokenFrom.address ? new currency_1.Token(tokenFrom) : currency_1.Native.onChain(this.chainId),
            output: tokenTo.address ? new currency_1.Token(tokenTo) : currency_1.Native.onChain(this.chainId),
            fee: poolFee * 100,
            poolAddress,
            poolType,
            absolutePortion,
        }));
    }
    minimumAmountOut(slippageTolerance) {
        (0, tiny_invariant_1.default)(!slippageTolerance.lessThan(math_1.ZERO), 'SLIPPAGE_TOLERANCE');
        const slippageAdjustedAmountOut = new math_1.Fraction(math_1.ONE)
            .add(slippageTolerance)
            .invert()
            .multiply(this.outputAmount.quotient)
            .quotient;
        return currency_1.Amount.fromRawAmount(this.outputAmount.currency.wrapped, slippageAdjustedAmountOut);
    }
    static bestTradeFromAPIRoute(chainId, fromToken, toToken, amountIn, amountOut, priceImpact, routeLegs, callMethod, writeArgs) {
        const inputAmount = currency_1.Amount.fromRawAmount(fromToken, amountIn);
        const outputAmount = currency_1.Amount.fromRawAmount(toToken, amountOut);
        return new AggregatorTrade(chainId, inputAmount, outputAmount, new currency_1.Price(fromToken, toToken, inputAmount.quotient, outputAmount.quotient), new math_1.Percent(Number.parseInt((priceImpact * 10000).toString()), 10000), routeLegs, callMethod, writeArgs);
    }
}
exports.AggregatorTrade = AggregatorTrade;
